import { render, staticRenderFns } from "./PersonsalData.vue?vue&type=template&id=7745dc34"
import script from "./PersonsalData.vue?vue&type=script&lang=js"
export * from "./PersonsalData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports